import React from 'react';
import { navigationRoutes } from '@app/utils/navigation-routes';
import { Route } from 'react-router-dom';
import { BreadcrumbsItem } from '@app/layouts/layout';
import { QmManageMonitoringTasks } from '@app/pages/qm-module/qm-manage-monitoring-tasks';

import MonitoringTaskMainSettings from '@app/pages/qm-module/qm-manage-monitoring-tasks/monitoring-task-main-settings';

import MonitoringTaskSettingsLayout from '@app/pages/qm-module/qm-manage-monitoring-tasks/blocks/monitoring-task-settings-layout';

import MonitoringTasksControllersTab from '@app/pages/qm-module/qm-manage-monitoring-tasks/blocks/monitoring-tasks-controllers-tab';

import MonitoringTaskSettingsRecords from '@app/pages/qm-module/qm-manage-monitoring-tasks/blocks/monitoring-task-settings-records';

import MonitoringTaskRecord from '@app/pages/qm-module/qm-manage-monitoring-tasks/blocks/monitoring-task-record.page';

import RequiredAuth from '../required-auth.route';

export const qmManageMonitoringTasksRoute = (
  <Route
    path={navigationRoutes.qm_manage_monitoring_tasks}
    handle={{
      crumb: () => (
        <BreadcrumbsItem path={navigationRoutes.qm_manage_monitoring_tasks} crumb="qm_manage" />
      ),
    }}
  >
    <Route
      index
      handle={{
        crumb: () => (
          <BreadcrumbsItem path={navigationRoutes.qm_manage_monitoring_tasks} crumb="qm_manage" />
        ),
      }}
      element={
        <RequiredAuth>
          <QmManageMonitoringTasks />
        </RequiredAuth>
      }
    />
    <Route
      path=":id"
      handle={{
        crumb: () => (
          <BreadcrumbsItem path={navigationRoutes.qm_manage_monitoring_tasks} crumb="qm_manage" />
        ),
      }}
      element={
        <RequiredAuth>
          <MonitoringTaskSettingsLayout />
        </RequiredAuth>
      }
    >
      <Route index element={<MonitoringTaskMainSettings />} />
      <Route
        path={navigationRoutes.qm_manage_monitoring_tasks_controllers}
        element={<MonitoringTasksControllersTab />}
      />
      <Route
        path={navigationRoutes.qm_manage_monitoring_tasks_monitoring}
        element={<MonitoringTaskSettingsRecords />}
      />
    </Route>
    <Route path=":recordMonitoringFormId/:recordId" element={<MonitoringTaskRecord />} />
  </Route>
);
